// Flatten n-dimensional array to 1-dimensional array. Taken from https://stackoverflow.com/a/15030117.
export const flatten = (arr) => {
    return arr.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
};


// WEBPACK FOOTER //
// ./src/common/src/util/arrayUtil.js